import { render, staticRenderFns } from "./Wallet.vue?vue&type=template&id=4885e4a8&scoped=true&"
import script from "./Wallet.vue?vue&type=script&lang=js&"
export * from "./Wallet.vue?vue&type=script&lang=js&"
import style0 from "./Wallet.vue?vue&type=style&index=0&id=4885e4a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4885e4a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
